import MachinesApi from "./machinesApi";
import OrganizationApi from "./organizationApi";

import {
  getMachineStatusLastByMachineId,
  getMachineStatusLastByMachineIds
} from "@/stores/helpers/machinesHelper";
import { dataToStatus } from "@/stores/helpers/machineStatusHelper";
import BaseApi from "./baseApi";

class FactoryMachinesApi extends BaseApi {
  constructor(organizationCode) {
    super(organizationCode);

    this.machinesApi = new MachinesApi();
    this.organizationApi = new OrganizationApi();
  }

  async saveMachines(params) {
    let result;

    if (params) {
      const patch = params.reduce((acc, el) => {
        acc.push(
          this.machinesApi.patchMachineById(el.Id, {
            Map_View: el.Map_View
          })
        );
        return acc;
      }, []);

      result = await Promise.all(patch);
    } else {
      result = Promise.resolve(null);
    }

    return result;
  }

  async getBackgroundUrl(organizationCode) {
    let backgroundUrl = undefined;

    try {
      const result = await this.organizationApi.getOrganization(organizationCode);
      backgroundUrl = result && result.Map_View && result.Map_View.BackgroundUrl;
    } catch (e) {
      console.error("[Error] Get background image error", e);
    }

    return backgroundUrl;
  }

  async getAllMachines(groupId) {
    let machines = undefined;

    try {
      const result = await this.getMachines(0, 1000, groupId, []);

      machines = result || [];
    } catch (e) {
      console.error("[Error] Get all machine error", e);
    }

    return machines;
  }

  async getMachines(skip = 0, limit = 1, groupId, machines) {
    if (groupId) {
      try {
        const result = await this.machinesApi.getMachinesByGroupId(groupId, {
          skip,
          limit
        });
        machines.push(...result.result);

        if (machines.length > 0 && result.total > machines.length) {
          machines = await this.getMachines(machines.length, result.total, groupId, machines);
        }
      } catch (e) {
        console.error("[Error] Fetch all machine error", e);
        machines = [];
      }
    }

    return machines;
  }

  async getMultipleStatus(machineIds) {
    try {
      if (machineIds?.length === 0) {
        return [];
      }
      const result = await getMachineStatusLastByMachineIds(machineIds);
      return result.map(item => {
        const status = dataToStatus(item);
        return {
          machineId: item.MachineId,
          status: {
            color: status.color ?? "black",
            raw: status.raw ?? undefined,
            timestamp: status.timestamp ?? undefined
          }
        };
      });
    } catch (e) {
      return [];
    }
  }

  async getSingleStatus(machineId) {
    let color = "black";
    let raw = undefined;
    let timestamp = undefined;

    try {
      const result = await getMachineStatusLastByMachineId(machineId);
      const status = dataToStatus(result);

      color = status.color;
      raw = status.raw;
      timestamp = status.timestamp;
    } catch (e) {
      color = "black";
    }

    return { color, raw, timestamp };
  }

  async getMachinesStatus(machines) {
    let result = [];

    if (machines) {
      const machineIds = machines.map(machine => machine.Id);
      const params = await this.getMultipleStatus(machineIds);
      result = (await Promise.all(params)).map(item => {
        return {
          machine: machines.find(m => m.Id === item.machineId),
          status: item.status
        };
      });
    }

    return result;
  }
}

export const factoryMachinesApi = new FactoryMachinesApi();
